<template>
  <!-- 查看合同页面 -->
  <div class="wrap" style="overflow: hidden">
    <yd-navbar title="新增合同" fontsize="16px" style="font-weight: 800;font-family:PingFang SC;color:#000">
      <router-link to="/supplierIndex" slot="left">
        <yd-navbar-back-icon></yd-navbar-back-icon>
      </router-link>
    </yd-navbar>
    <yd-cell-group>
      <yd-cell-item style="padding:.5em 0">
        <span slot="left">合同编号：</span>
        <!-- <yd-input slot="right" required v-model="form.contractNo" min="4" max="50" placeholder="例：CQYT-******"></yd-input>-->
        <yd-textarea v-model="form.contractNo" slot="right" placeholder="例：2024-MM-****" minlength="3" maxlength="200" style="border: 1px solid #ccc;padding:.5em;border-radius: 6px;"></yd-textarea>
      </yd-cell-item>
<!--      <yd-cell-item  style="padding:.5em 0">-->
<!--        <span slot="left">合同名称：</span>-->
<!--        &lt;!&ndash; <yd-input slot="right" required type="text" v-model="form.contractName" min="4" max="100" placeholder="例：长庆油田-*****"></yd-input>&ndash;&gt;-->
<!--        <yd-textarea v-model="form.contractName" slot="right" placeholder="例：长庆油田-*****" minlength="1" maxlength="200" style="border: 1px solid #ccc;padding:.5em;border-radius: 6px;"></yd-textarea>-->
<!--      </yd-cell-item>-->
      <yd-cell-item>
        <span slot="left">供应商编码：</span>
        <yd-input slot="right" required type="text" disabled="true" v-model="form.supplierNo" placeholder="例：10000-*****"></yd-input>
      </yd-cell-item>
      <yd-cell-item>
        <span slot="left">供应商名称：</span>
        <yd-input slot="right" required type="text" disabled="true" v-model="form.supplierName" placeholder="例：*****"></yd-input>
      </yd-cell-item>
      <yd-cell-item>
        <span slot="left">报审序号：</span>
        <yd-input slot="right" required type="text" v-model="form.contractNoArea" min="2" max="50" placeholder="例：2023-*****"></yd-input>
      </yd-cell-item>
      <div style="text-align: left;padding-left: 12px;padding-bottom: 12px;">
        <span slot="left" style="color: #2f6fff;font-size: 11px">变更或解除合同，请在报审序号前加说明，例：一次变更2023-*****</span>
      </div>
      <yd-cell-item>
        <span slot="left">承办人：</span>
        <yd-input slot="right" required type="text" v-model="form.signUserName" placeholder="请输入业务部门办理人"></yd-input>
      </yd-cell-item>
      <yd-cell-item>
        <span slot="left">签订时间：</span>
        <yd-input slot="right" required type="date" v-model="form.signDate" placeholder="请输入签订时间"></yd-input>
      </yd-cell-item>
    </yd-cell-group>
    <yd-button type="primary" size="large" shape="circle" bgcolor="#2f6fff" color="#fff" @click.native="submitContract">提交</yd-button>
    <yd-button type="hollow" size="large" shape="circle" style="border: #2f6fff 1px solid;" @click.native="resetForm">重置</yd-button>
    <yd-tabbar class="tabbar-footer" active-color="#004EFF">
      <yd-tabbar-item title="首页" link="#" active>
        <yd-icon name="home" slot="icon" size="0.54rem" color=""></yd-icon>
      </yd-tabbar-item>
      <yd-tabbar-item title="我的预约" link="supplierList">
        <yd-icon name="checkoff" slot="icon" size="0.54rem"></yd-icon>
      </yd-tabbar-item>
      <yd-tabbar-item title="个人中心" link="supplierInfo">
        <yd-icon name="ucenter-outline" slot="icon" size="0.54rem"></yd-icon>
      </yd-tabbar-item>
    </yd-tabbar>

    <yd-popup v-model="saveTip" position="center" width="80%">
      <yd-button type="primary" size="large" shape="circle" bgcolor="#2f6fff" color="#fff" @click.native="nextAdd">继续添加</yd-button>
      <yd-button type="hollow" size="large" shape="circle" style="border: #2f6fff 1px solid;" @click.native="toIndex">返回首页</yd-button>
    </yd-popup>

  </div>
</template>

<script>
import axios from "axios";
var baseUrl = process.env.API_ROOT;
export default {
    data() {
        return {
          saveTip:false,
          form:{
           contractNo:'',
           contractName:'',
           supplierNo:this.$route.query.supplierUser.supplier_no,
           supplierName:this.$route.query.supplierUser.supplier_name,
           contractNoArea:'',
           signDate:'',
           signUserName:'',
          },
           userId:window.localStorage.getItem("checkUserId"),
        }
    },
    methods: {
      toIndex(){
        this.$router.push({ path: "/supplierIndex"});
      },
      nextAdd(){
        this.saveTip = false
        this.resetForm()
      },
      submitContract(){
        if(!this.form.contractNo || this.form.contractNo.length <=5){
          this.$dialog.toast({ mes: "请正确输入合同编号", timeout: 1500 });
           return
        }
        // else if(!this.form.contractName || this.form.contractName.length <=5){
        //   this.$dialog.toast({ mes: "请正确输入合同名称", timeout: 1500 });
        //    return
        // }
        else if(!this.form.supplierNo || this.form.supplierNo.length <=1){
          this.$dialog.toast({ mes: "供应商编码获取异常，请返回重新添加", timeout: 1500 });
           return
        }else if(!this.form.supplierName || this.form.supplierName.length <=1){
          this.$dialog.toast({ mes: "供应商名称获取异常，请返回重新添加", timeout: 1500 });
           return
        }else if(!this.form.contractNoArea || this.form.contractNoArea.length <=2){
          this.$dialog.toast({ mes: "请正确输入报审序号", timeout: 1500 });
           return
        } else if(!this.form.signDate){
          this.$dialog.toast({ mes: "请正确输入签订时间", timeout: 1500 });
           return
        } else if(!this.form.signUserName || this.form.signUserName.length <=1 ){
          this.$dialog.toast({ mes: "请输入业务部门办理人", timeout: 1500 });
          return
        }
    axios({
         method: "post",
          url: baseUrl + "addContract",
          params:{
                contractNo:this.form.contractNo,
                contractName:this.form.contractName,
                contractNoArea:this.form.contractNoArea,
                signDate:this.form.signDate,
                signUserName:this.form.signUserName,
                supplierNo:this.form.supplierNo,
                supplierName:this.form.supplierName,
                createBy:window.localStorage.getItem("checkUserId"),
                updateBy:window.localStorage.getItem("checkUserId")
            }
        }).then(resp => {
          if (resp.data.error_code == "0") {
              this.saveTip = true
          } else{
            this.$dialog.toast({ mes: resp.data.error_msg, timeout: 1500 });
          }
        })


      },
      resetForm(){
        this.form.contractNo = ''
        this.form.contractName = ''
        this.form.contractNoArea = ''
        this.form.orderDate = ''
      },
      getSupplierUser(){
        axios({
          method: "get",
          url: baseUrl + "supplierUser?userId="+userId
        }).then(resp => {
          if (resp.data.error_code == "0") {
            this.supplierNo = resp.data.supplier_no
            this.supplierName = resp.data.supplier_name
          }
          })
      }
    },
  mounted() {
   if(!this.userId){
      this.$router.push({ path: "/login"});
   }
  // this.getSupplierUser()
  }
}
</script>

<style scoped>
.tabbar-footer {
  position: fixed;
  bottom: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/supplier-add.vue